import React, { createContext, useContext, useState } from "react";

export enum DrawerContentType {
  REPORT_ISSUE = "report_issue",
  ASK_QUESTION = "ask_question",
  VIEW_DETAILS = "view_details",
}

type DrawerState = {
  drawerContentType: DrawerContentType | null;
  setDrawerContentType: (type: DrawerContentType | null) => void;
};

const DrawerContext = createContext<DrawerState | undefined>(undefined);

export const DrawerContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [drawerContentType, setDrawerContentType] =
    useState<DrawerContentType | null>(null);

  return (
    <DrawerContext.Provider
      value={{
        drawerContentType,
        setDrawerContentType,
      }}
    >
      {children}
    </DrawerContext.Provider>
  );
};

export const useDrawerContext = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error(
      "useDrawerContext must be used within a DrawerContextProvider"
    );
  }
  return context;
};
